import React from 'react';

import { Typography, useMediaQuery } from 'fronton-react';
import { FlexColumnBlock } from '../styled';

export const Paragraphs = ({ data }: { data: string[] }) => {
	const isMobile = useMediaQuery('(max-width: 767px)');
	return (
		<FlexColumnBlock>
			{data.map(elem => (
				<Typography size="body_long" variant={isMobile ? 'm' : 'l'} key={elem}>
					{elem}
				</Typography>
			))}
		</FlexColumnBlock>
	);
};
